"use client";

import { c as _c } from "react/compiler-runtime";
import type { CampaignPageSection } from "@growwithai/shared";
import { isSafeHref } from "../types";
import { sectionBgStyle } from "../section-style";
type ButtonSectionData = Extract<CampaignPageSection, {
  type: "button";
}>;
const FONT_SIZE_REM: Record<string, string> = {
  sm: "0.8125rem",
  lg: "1.0625rem",
  xl: "1.25rem"
};

/** Tombol CTA berdiri sendiri — beda dari 'links' (daftar) & CTA bawaan 'hero'. */
export default function ButtonSection(t0) {
  const $ = _c(21);
  const {
    section
  } = t0;
  if (!isSafeHref(section.href)) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = /^https?:\/\//i;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== section.href) {
    t2 = t1.test(section.href);
    $[1] = section.href;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const external = t2;
  const alignClass = section.align === "left" ? "justify-start" : "justify-center";
  const styleClass = section.style === "outline" ? "border-2 border-[var(--brand-primary)] text-[var(--brand-primary)] hover:bg-[color-mix(in_srgb,var(--brand-primary)_8%,white)]" : "bg-[var(--brand-primary)] text-[var(--brand-on-primary,#fff)] shadow-sm hover:bg-[var(--brand-primary-hover)]";
  let t3;
  if ($[3] !== section.custom_style) {
    t3 = {
      ...(section.custom_style?.text_color ? {
        color: section.custom_style.text_color
      } : {}),
      ...(section.custom_style?.font_size && FONT_SIZE_REM[section.custom_style.font_size] ? {
        fontSize: FONT_SIZE_REM[section.custom_style.font_size]
      } : {})
    };
    $[3] = section.custom_style;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const labelStyle = t3;
  let t4;
  if ($[5] !== section.custom_style) {
    t4 = sectionBgStyle(section.custom_style);
    $[5] = section.custom_style;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = `mx-auto flex max-w-2xl px-5 ${alignClass}`;
  let t6;
  if ($[7] !== external) {
    t6 = external ? {
      target: "_blank",
      rel: "noopener noreferrer"
    } : {};
    $[7] = external;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const t7 = `inline-flex h-12 items-center justify-center rounded-xl px-8 text-sm font-semibold transition-colors ${styleClass}`;
  let t8;
  if ($[9] !== labelStyle || $[10] !== section.href || $[11] !== section.label || $[12] !== t6 || $[13] !== t7) {
    t8 = <a href={section.href} {...t6} className={t7} style={labelStyle}>{section.label}</a>;
    $[9] = labelStyle;
    $[10] = section.href;
    $[11] = section.label;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t5 || $[16] !== t8) {
    t9 = <div className={t5}>{t8}</div>;
    $[15] = t5;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t4 || $[19] !== t9) {
    t10 = <section className="bg-white py-8" style={t4}>{t9}</section>;
    $[18] = t4;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
}